export const BROADCAST_COLUMNS = [
  { id: 'name', label: 'Name', alwaysVisible: true },
  { id: 'status', label: 'Status' },
  { id: 'sent', label: 'Sent' },
  { id: 'created', label: 'Created' },
  { id: 'author', label: 'Author', defaultHidden: true },
  { id: 'queued', label: 'Queued' },
  { id: 'failed', label: 'Failed' },
  { id: 'delivered', label: 'Delivered' },
  { id: 'opened', label: 'Opened' },
  { id: 'clicked', label: 'Clicked' },
  { id: 'converted', label: 'Converted' },
  { id: 'bounced', label: 'Bounced', defaultHidden: true },
  { id: 'suppressed', label: 'Suppressed', defaultHidden: true },
  { id: 'actions', label: 'Actions', alwaysVisible: true, pinnedLast: true },
];

export const BROADCAST_STATUSES = {
  not_scheduled: { label: 'Not Scheduled', color: 'gray' },
  scheduled: { label: 'Scheduled', color: 'gray' },
  sending: { label: 'Sending', color: 'warning' },
  sent: { label: 'Sent', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
};

export const DATE_FILTER_KEYS = ['created', 'sent'];

export const rate = (count, delivered) => (delivered > 0 ? `${((count / delivered) * 100).toFixed(1)}%` : '0.0%');

const pad = (number) => String(number).padStart(2, '0');

export const toIsoDate = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const fromIsoDate = (iso) => {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const timeAgo = (iso, now = new Date()) => {
  const minutes = Math.round((now - new Date(iso)) / 60000);
  const steps = [[60, 'minute'], [24, 'hour'], [30, 'day'], [12, 'month'], [Infinity, 'year']];
  let value = minutes;
  for (const [size, unit] of steps) {
    if (value < size) return new Intl.RelativeTimeFormat('en', { numeric: 'auto' }).format(-Math.max(value, 0), unit);
    value = Math.floor(value / size);
  }
  return '';
};
